import { createFileRoute, redirect } from '@tanstack/react-router';

export const Route = createFileRoute('/_staff/payroll-engine/_layout/')({
  beforeLoad: () => {
    throw redirect({ to: '/payroll-engine/payroll-structures' });
  },
});
